import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { TABS } from "../../pages/forms/formValidationMapping";

// Guided step navigation replacing the old flat <Tabs>/<Tab> bar --
// presentation-only: every step click still just calls the same
// setActiveTab the old <Tabs onSelect> did, so nothing about how content
// panels render or how validation errors are classified changes. The
// "Publish" step is deliberately NOT one of the 4 TABS.* values (it has no
// content panel of its own -- it's an action that opens the readiness
// drawer), so it's appended separately and routed through onPublishClick
// instead of onSelect.
const CONTENT_STEPS = [
  { id: TABS.STRUCTURE, label: "Structure" },
  { id: TABS.SCORING, label: "Scoring" },
  { id: TABS.EXECUTION_PROFILE, label: "Execution Profile" },
  { id: TABS.PREVIEW, label: "Preview" },
];

function contentStepStatus(stepId, { activeTab, errorsByTab, visitedSteps }) {
  if ((errorsByTab[stepId] || []).length > 0) return "error";
  if (activeTab === stepId) return "current";
  if (visitedSteps.has(stepId)) return "done";
  return "pending";
}

function StepIcon({ status, index }) {
  if (status === "done") return <CheckCircleIcon fontSize="small" aria-hidden="true" />;
  if (status === "error") return <ErrorIcon fontSize="small" aria-hidden="true" />;
  return <span className="form-builder-stepnav-index">{index}</span>;
}

export default function FormBuilderStepNav({ activeTab, onSelect, errorsByTab, visitedSteps, publishStatus, onPublishClick }) {
  return (
    <nav className="form-builder-stepnav" aria-label="Form builder steps">
      <ol className="form-builder-stepnav-list">
        {CONTENT_STEPS.map((step, idx) => {
          const status = contentStepStatus(step.id, { activeTab, errorsByTab, visitedSteps });
          return (
            <li key={step.id} className={`form-builder-stepnav-item is-${status}`}>
              <button
                type="button"
                className="form-builder-stepnav-btn"
                onClick={() => onSelect(step.id)}
                aria-current={status === "current" ? "step" : undefined}
              >
                <StepIcon status={status} index={idx + 1} />
                <span className="form-builder-stepnav-label">{step.label}</span>
              </button>
            </li>
          );
        })}
        <li className={`form-builder-stepnav-item form-builder-stepnav-item-publish is-${publishStatus}`}>
          <button type="button" className="form-builder-stepnav-btn" onClick={onPublishClick}>
            {publishStatus === "blocked" ? (
              <ErrorIcon fontSize="small" aria-hidden="true" />
            ) : (
              <SendOutlinedIcon fontSize="small" aria-hidden="true" />
            )}
            <span className="form-builder-stepnav-label">Publish</span>
          </button>
        </li>
      </ol>
    </nav>
  );
}
